import { COREUI_DEVICE_ICON_MAPPING, ICON_MAPPING } from './icons'
import * as battery0 from '@/../images/device_icons/tecget/battery0.svg'
import * as battery20 from '@/../images/device_icons/tecget/battery20.svg'
import * as battery40 from '@/../images/device_icons/tecget/battery40.svg'
import * as battery60 from '@/../images/device_icons/tecget/battery60.svg'
import * as battery80 from '@/../images/device_icons/tecget/battery80.svg'
import * as battery100 from '@/../images/device_icons/tecget/battery100.svg'
import * as chp from '@/../images/device_icons/tecget/chp.svg'
import * as container from '@/../images/device_icons/tecget/container.svg'
import * as containerAlarm from '@/../images/device_icons/tecget/container_alarm.svg'
import * as containerOk from '@/../images/device_icons/tecget/container_ok.svg'
import * as containerWarning from '@/../images/device_icons/tecget/container_warning.svg'
import * as coreuiDeviceIcons from '@/../images/device_icons/tecget/coreui_device_icons'
import * as dashboardCenterIcon from '@/../images/device_icons/tecget/dashboard_center_icon.svg'
import * as wallbox from '@/../images/device_icons/tecget/wallbox.svg'
import * as wallboxPlugged from '@/../images/device_icons/tecget/wallbox_plugged.svg'
import * as wallboxUnplugged from '@/../images/device_icons/tecget/wallbox_unplugged.svg'
import * as wallboxWarning from '@/../images/device_icons/tecget/wallbox_warning.svg'
import * as fuelcell from '@/../images/device_icons/tecget/fuelcell.svg'
import * as generic from '@/../images/device_icons/tecget/generic.svg'
import * as grid from '@/../images/device_icons/tecget/grid.svg'
import * as heatingelement from '@/../images/device_icons/tecget/heatingelement.svg'
import * as heatpump from '@/../images/device_icons/tecget/heatpump.svg'
import * as pv from '@/../images/device_icons/tecget/pv.svg'
import * as rest from '@/../images/device_icons/tecget/rest.svg'
import * as trafo from '@/../images/device_icons/tecget/trafo.svg'
import * as user from '@/../images/device_icons/tecget/user.svg'

const map = {
  battery: battery0,
  battery0,
  battery20,
  battery40,
  battery60,
  battery80,
  battery100,
  chp,
  container,
  containerAlarm,
  containerOk,
  containerWarning,
  dashboardCenterIcon,
  fuelcell,
  generic,
  grid,
  heatingelement,
  heatpump,
  pv,
  rest,
  trafo,
  user,
  wallbox,
  wallboxPlugged,
  wallboxUnplugged,
  wallboxWarning
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}

export function overwriteCoreuiDeviceIcons() {
  Object.assign(COREUI_DEVICE_ICON_MAPPING, coreuiDeviceIcons)
}
